var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var config = {
  env: "prod",
  mode: "prod",
  version: "1.0.0-beta.18"
};
class Animator {
  constructor(video, op) {
    this.frameDelay = 0;
    this.frameStartTime = 0;
    this.currentTimeMillsecond = () => {
      if (typeof performance === "undefined") {
        return new Date().getTime();
      }
      return performance.now();
    };
    this.drawFrame = (now = this.currentTimeMillsecond(), metadata) => {
      if (!this.isPlay)
        return;
      this.cancelAnim();
      this.requestAnim(this.drawFrame);
      const mediaTime = (metadata == null ? void 0 : metadata.mediaTime) || this.video.currentTime;
      const frame = this.getCurrentFrame(mediaTime);
      this.onUpdate && this.onUpdate(frame);
    };
    this.video = video;
    this.op = op;
    this.isPlay = false;
    if ("requestVideoFrameCallback" in HTMLVideoElement.prototype && this.op.useAccurate) {
      Animator.animationType = "requestVideoFrameCallback";
    } else if (typeof requestAnimationFrame !== "undefined") {
      Animator.animationType = "requestAnimationFrame";
    } else {
      Animator.animationType = "setTimeout";
    }
    this.requestAnim = this.returnRequestAnim();
    this.cancelAnim = this.returnCancelAnim();
  }
  async setup() {
    this.frameDelay = 1e3 / VideoEntity.fps;
  }
  start() {
    if (this.frameDelay === 0 && VideoEntity.fps > 0)
      this.frameDelay = 1e3 / VideoEntity.fps;
    logger.debug("animator start", this.animateId, this.frameDelay, VideoEntity.fps);
    this.frameStartTime = this.currentTimeMillsecond();
    this.cancelAnim();
    this.requestAnim(this.drawFrame);
  }
  stop() {
    logger.debug("animator stop", this.animateId);
    this.cancelAnim();
  }
  destroy() {
    logger.debug("[animator destroy]", this.animateId);
    this.cancelAnim();
    this.op = void 0;
    this.video = void 0;
    this.cancelAnim = void 0;
    this.requestAnim = void 0;
    this.onUpdate = void 0;
  }
  getCurrentFrame(mediaTime = 0) {
    return Math.round(mediaTime * VideoEntity.VideoFps) + (this.op.offset || 0);
  }
  returnRequestAnim() {
    switch (Animator.animationType) {
      case "requestVideoFrameCallback":
        return (fn) => this.animateId = this.video.requestVideoFrameCallback(fn);
      case "requestAnimationFrame":
        return (fn) => {
          return requestAnimationFrame(() => {
            const now = this.currentTimeMillsecond();
            const delta = now - this.frameStartTime;
            if (delta > this.frameDelay) {
              this.frameStartTime = now - delta % this.frameDelay;
              return fn();
            }
            if (this.requestAnim)
              this.animateId = this.requestAnim(fn);
          });
        };
      default:
        return (fn) => this.animateId = setTimeout(fn, 1e3 / VideoEntity.fps);
    }
  }
  returnCancelAnim() {
    switch (Animator.animationType) {
      case "requestVideoFrameCallback":
        return () => this.animateId && this.video.cancelVideoFrameCallback(this.animateId);
      case "requestAnimationFrame":
        return () => this.animateId && cancelAnimationFrame(this.animateId);
      default:
        return () => this.animateId && clearTimeout(this.animateId);
    }
  }
}
class Webgl {
  constructor(op) {
    this.PER_SIZE = 9;
    if (op.useOfsRender) {
      this.canvas = document.createElement("canvas");
      this.ctx = this.canvas.getContext("2d");
      op.container.appendChild(this.canvas);
      if (op.resizeCanvas) {
        this.setSizeCanvas(this.canvas, op.resizeCanvas);
      }
      this.ofs = !!self.OffscreenCanvas && !!self.createImageBitmap && op.useBitmap ? new OffscreenCanvas(300, 300) : document.createElement("canvas");
    } else {
      this.ofs = document.createElement("canvas");
      if (op.resizeCanvas) {
        this.setSizeCanvas(this.ofs, op.resizeCanvas);
      }
      op.container.appendChild(this.ofs);
    }
    this.initGlContext();
    this.op = op;
  }
  setSizeCanvas(canvas, resizeCanvas) {
    switch (resizeCanvas) {
      case "percent":
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        break;
      case "percentH":
        canvas.style.height = "100%";
        break;
      case "percentW":
        canvas.style.width = "100%";
        break;
    }
  }
  initGlContext() {
    const canvas = this.ofs;
    const op = {
      alpha: true,
      antialias: false,
      depth: true,
      failIfMajorPerformanceCaveat: false,
      premultipliedAlpha: true,
      stencil: false,
      preserveDrawingBuffer: false
    };
    this.gl = canvas.getContext("webgl2", op);
    Webgl.version = 2;
    if (!this.gl) {
      this.gl = canvas.getContext("webgl", op);
      Webgl.version = 1;
      if (!this.gl) {
        Webgl.version = "canvas2d";
      }
    }
  }
  destroy() {
    if (this.gl) {
      this.gl.clear(this.gl.COLOR_BUFFER_BIT);
      this.gl = null;
    }
    if (this.canvas)
      this.canvas.remove();
    if (this.ofs instanceof HTMLCanvasElement) {
      this.ofs.remove();
      this.gl = null;
      logger.debug("[destroy remove canvas]");
    } else
      this.ofs = void 0;
  }
  getVsSource() {
    const cb = Webgl.version === 2 ? this.getVs2() : this.getVs1();
    return cb;
  }
  getFsSource() {
    const cb = Webgl.version === 2 ? this.getFs2() : this.getFs1();
    return cb;
  }
  getVs2() {
    return `#version 300 es
    in vec2 a_position; // \u63A5\u53D7\u9876\u70B9\u5750\u6807
    in vec2 a_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807
    in vec2 a_alpha_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807
    out vec2 v_alpha_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807
    out vec2 v_texcoord; // \u4F20\u9012\u7EB9\u7406\u5750\u6807\u7ED9\u7247\u5143\u7740\u8272\u5668
    uniform vec2 u_scale;
    void main(void) {
      gl_Position = vec4(u_scale * a_position, 0.0, 1.0); // \u8BBE\u7F6E\u5750\u6807
      v_texcoord = a_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807
      v_alpha_texCoord = a_alpha_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807
    }
    `;
  }
  getVs1() {
    return `attribute vec2 a_position; // \u63A5\u53D7\u9876\u70B9\u5750\u6807
    attribute vec2 a_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807
    attribute vec2 a_alpha_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807
    varying vec2 v_alpha_texCoord; // \u63A5\u53D7\u7EB9\u7406\u5750\u6807
    varying vec2 v_texcoord; // \u4F20\u9012\u7EB9\u7406\u5750\u6807\u7ED9\u7247\u5143\u7740\u8272\u5668
    uniform vec2 u_scale;
    void main(void){
       gl_Position = vec4(u_scale * a_position, 0.0, 1.0); // \u8BBE\u7F6E\u5750\u6807
       v_texcoord = a_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807
       v_alpha_texCoord = a_alpha_texCoord; // \u8BBE\u7F6E\u7EB9\u7406\u5750\u6807
    }`;
  }
  getFs2() {
    if (!this.gl)
      return "";
    const gl = this.gl;
    const bgColor = `vec4(texture(u_image_video, v_texcoord).rgb, texture(u_image_video,v_alpha_texCoord).r);`;
    const textureSize = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1;
    let sourceTexure = "";
    let sourceUniform = "";
    if (textureSize > 0 && (this.op.dataUrl || this.op.useMetaData)) {
      const imgColor = [];
      const samplers = [];
      for (let i = 0; i < textureSize; i++) {
        imgColor.push(`if(ndx == ${i + 1}){
                          color = texture(u_image${i + 1},uv);
                      }`);
        samplers.push(`uniform sampler2D u_image${i + 1};`);
      }
      sourceUniform = `
              ${samplers.join("\n")}
              uniform float image_pos[${textureSize * this.PER_SIZE}];
              vec4 getSampleFromArray(int ndx, vec2 uv) {
                  vec4 color;
                  ${imgColor.join(" else ")}
                  return color;
              }
              `;
      sourceTexure = `
              vec4 srcColor,maskColor;
              vec2 srcTexcoord,maskTexcoord;
              int srcIndex;
              float x1,x2,y1,y2,mx1,mx2,my1,my2; //\u663E\u793A\u7684\u533A\u57DF

              for(int i=0;i<${textureSize * this.PER_SIZE};i+= ${this.PER_SIZE}){
                  if ((int(image_pos[i]) > 0)) {
                    srcIndex = int(image_pos[i]);

                      x1 = image_pos[i+1];
                      x2 = image_pos[i+2];
                      y1 = image_pos[i+3];
                      y2 = image_pos[i+4];

                      mx1 = image_pos[i+5];
                      mx2 = image_pos[i+6];
                      my1 = image_pos[i+7];
                      my2 = image_pos[i+8];


                      if (v_texcoord.s>x1 && v_texcoord.s<x2 && v_texcoord.t>y1 && v_texcoord.t<y2) {
                          srcTexcoord = vec2((v_texcoord.s-x1)/(x2-x1),(v_texcoord.t-y1)/(y2-y1));
                           maskTexcoord = vec2(mx1+srcTexcoord.s*(mx2-mx1),my1+srcTexcoord.t*(my2-my1));
                           srcColor = getSampleFromArray(srcIndex,srcTexcoord);
                           maskColor = texture(u_image_video, maskTexcoord);
                           srcColor.a = srcColor.a*(maskColor.r);

                           bgColor = vec4(srcColor.rgb*srcColor.a,srcColor.a) + (1.0-srcColor.a)*bgColor;

                      }
                  }
              }
              `;
    }
    return `#version 300 es
      precision lowp float;
      in vec2 v_texcoord;
      in vec2 v_alpha_texCoord;
      out vec4 fragColor;
      uniform sampler2D u_image_video;
      ${sourceUniform}

      void main(void) {
          vec4 bgColor = ${bgColor}
          ${sourceTexure}
          fragColor = bgColor;
      }
      `;
  }
  getFs1() {
    if (!this.gl)
      return "";
    const gl = this.gl;
    const bgColor = `vec4(texture2D(u_image_video, v_texcoord).rgb, texture2D(u_image_video,v_alpha_texCoord).r);`;
    const textureSize = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1;
    let sourceTexure = "";
    let sourceUniform = "";
    if (textureSize > 0) {
      const imgColor = [];
      const samplers = [];
      for (let i = 0; i < textureSize; i++) {
        imgColor.push(`if(ndx == ${i + 1}){
                          color = texture2D(u_image${i + 1},uv);
                      }`);
        samplers.push(`uniform sampler2D u_image${i + 1};`);
      }
      sourceUniform = `
              ${samplers.join("\n")}
              uniform float image_pos[${textureSize * this.PER_SIZE}];
              vec4 getSampleFromArray(int ndx, vec2 uv) {
                  vec4 color;
                  ${imgColor.join(" else ")}
                  return color;
              }
              `;
      sourceTexure = `
              vec4 srcColor,maskColor;
              vec2 srcTexcoord,maskTexcoord;
              int srcIndex;
              float x1,x2,y1,y2,mx1,mx2,my1,my2; //\u663E\u793A\u7684\u533A\u57DF

              for(int i=0;i<${textureSize * this.PER_SIZE};i+= ${this.PER_SIZE}){
                  if ((int(image_pos[i]) > 0)) {
                    srcIndex = int(image_pos[i]);

                      x1 = image_pos[i+1];
                      x2 = image_pos[i+2];
                      y1 = image_pos[i+3];
                      y2 = image_pos[i+4];

                      mx1 = image_pos[i+5];
                      mx2 = image_pos[i+6];
                      my1 = image_pos[i+7];
                      my2 = image_pos[i+8];


                      if (v_texcoord.s>x1 && v_texcoord.s<x2 && v_texcoord.t>y1 && v_texcoord.t<y2) {
                          srcTexcoord = vec2((v_texcoord.s-x1)/(x2-x1),(v_texcoord.t-y1)/(y2-y1));
                           maskTexcoord = vec2(mx1+srcTexcoord.s*(mx2-mx1),my1+srcTexcoord.t*(my2-my1));
                           srcColor = getSampleFromArray(srcIndex,srcTexcoord);
                           maskColor = texture2D(u_image_video, maskTexcoord);
                           srcColor.a = srcColor.a*(maskColor.r);

                           bgColor = vec4(srcColor.rgb*srcColor.a,srcColor.a) + (1.0-srcColor.a)*bgColor;

                      }
                  }
              }
              `;
    }
    return `
      precision lowp float;
      varying vec2 v_texcoord;
      varying vec2 v_alpha_texCoord;
      uniform sampler2D u_image_video;
      ${sourceUniform}

      void main(void) {
          vec4 bgColor = ${bgColor}
          ${sourceTexure}
          // bgColor = texture2D(u_image[0], v_texcoord);
          gl_FragColor = bgColor;
      }
      `;
  }
}
const prefixName = "YYEVA";
class Logger {
  constructor() {
    this.op = {
      level: "debug",
      channel: "",
      showtips: true
    };
    this.colors = {
      debug: "#3498db",
      info: "#16a085",
      warn: "#e67e22",
      error: "#e74c3c"
    };
    this.levels = {
      debug: 1,
      info: 2,
      warn: 3,
      error: 4
    };
  }
  logType(type) {
    const s = type.toLocaleUpperCase();
    let rs = [];
    if (this.op.showtips)
      rs = [
        `%c ${this.op.channel || prefixName} %c ${s} `,
        `background:#2c3e50;color:#fff;padding: 1px;border-radius: 2px 0 0 2px;`,
        `background:${this.colors[type]};color: #fff;padding: 1px; border-radius: 0 2px 2px 0;`
      ];
    return rs;
  }
  setup(options) {
    const { channel, level, showtips } = self.LoggerConfig || {};
    this.op = __spreadValues(__spreadValues({}, this.op), options);
    if (typeof showtips === "boolean")
      this.op.showtips = showtips;
    const lv = level ? this.levels[level] : this.op.level ? this.levels[this.op.level] : 2;
    const useChannel = !channel || channel === this.op.channel;
    const silenceFn = (...args) => {
    };
    this.error = lv <= 4 && useChannel ? console.error.bind(console, ...this.logType("error")) : silenceFn;
    this.warn = lv <= 3 && useChannel ? console.warn.bind(console, ...this.logType("warn")) : silenceFn;
    this.info = lv <= 2 && useChannel ? console.log.bind(console, ...this.logType("info")) : silenceFn;
    this.log = lv <= 2 && useChannel ? console.log.bind(console, ...this.logType("info")) : silenceFn;
    this.debug = lv <= 1 && useChannel ? console.log.bind(console, ...this.logType("debug")) : silenceFn;
  }
}
const logger = new Logger();
const versionTips = (op) => {
  if (op.showPlayerInfo === "table") {
    return console.table({
      Version: config.version,
      RenderType: op.renderType === "canvas2d" ? op.renderType : `WebGL.${Webgl.version}`,
      FPS: VideoEntity.fps,
      DisplayMode: op.mode,
      LoadType: op.usePrefetch ? " MSE" : "src",
      OffScreenRender: !!op.useOfsRender,
      UseFrameCache: !!op.useFrameCache,
      UseVideoDBCache: !!op.useVideoDBCache,
      AnimationType: Animator.animationType
    });
  }
  console.log(`%c ${prefixName} ${config.version} %c ${op.renderType === "canvas2d" ? op.renderType : `WebGL.${Webgl.version}`}${self.devicePixelRatio ? ` DPR.${self.devicePixelRatio}` : ""}${` FPS.${VideoEntity.fps}`}${op.mode ? ` ${op.mode}` : ""}${op.usePrefetch ? " MSE" : ""}${op.useOfsRender ? " OfsRender" : ""}${op.useFrameCache ? ` FrameCache` : ""}${op.useVideoDBCache ? ` VideoCache` : ""}${` ${Animator.animationType}`} %c`, "background:#34495e ; padding: 1px; border-radius: 2px 0 0 2px;  color: #fff", "background:#16a085 ; padding: 1px; border-radius: 0 2px 2px 0;  color: #fff", "background:transparent");
};
const isDataUrl = (url) => {
  const regex = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i;
  return regex.test(url);
};
const currentVideoId = Date.now();
const getVIdeoId = (url, isWeixin2) => {
  return !isWeixin2 ? url : `e-video-wx-${currentVideoId}`;
};
var EPlayError = /* @__PURE__ */ ((EPlayError2) => {
  EPlayError2["NotAllowedError"] = "NotAllowedError";
  return EPlayError2;
})(EPlayError || {});
var EPlayStep = /* @__PURE__ */ ((EPlayStep2) => {
  EPlayStep2["canplaythrough"] = "canplaythrough";
  EPlayStep2["muted"] = "muted";
  return EPlayStep2;
})(EPlayStep || {});
var EScaleMode = /* @__PURE__ */ ((EScaleMode2) => {
  EScaleMode2["aspectFill"] = "aspectFill";
  EScaleMode2["aspectFit"] = "aspectFit";
  EScaleMode2["scaleFill"] = "scaleFill";
  return EScaleMode2;
})(EScaleMode || {});
const _VideoEntity = class {
  constructor(op) {
    this.isUseMeta = false;
    this.effectTypes = {
      txt: ["txt", "text"],
      img: ["img", "image"]
    };
    this.effectWidth = "effectWidth";
    this.effectHeight = "effectHeight";
    this.effectTag = "effectTag";
    this.effectType = "effectType";
    this.effectId = "effectId";
    this.renderFrame = "renderFrame";
    this.outputFrame = "outputFrame";
    this.frameIndex = "frameIndex";
    this.scaleMode = "scaleMode";
    this.data = "data";
    this.op = op;
    const canvas = !!self.OffscreenCanvas ? new OffscreenCanvas(300, 300) : document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    this.ctx = ctx;
    this.ofs = canvas;
    if (op.useMetaData) {
      this.isUseMeta = true;
    }
    if (op.dataUrl) {
      this.effectHeight = "h";
      this.effectWidth = "w";
      this.effectTag = "srcTag";
      this.effectType = "srcType";
      this.effectId = "srcId";
      this.renderFrame = "frame";
      this.outputFrame = "mFrame";
      this.frameIndex = "i";
      this.data = "obj";
    }
  }
  destroy() {
    if (this.ofs) {
      this.ctx = null;
      if (this.ofs instanceof HTMLCanvasElement)
        this.ofs.remove();
      else
        this.ofs = void 0;
    }
    this.config = void 0;
  }
  setConfig(config2) {
    this.config = config2;
    if (config2.descript.fps) {
      _VideoEntity.fps = config2.descript.fps;
      _VideoEntity.VideoFps = config2.descript.fps;
    }
  }
  async setup() {
    if (this.op.dataUrl) {
      const { info, src, frame } = await this.getConfig(this.op.dataUrl);
      _VideoEntity.fps = info.fps || _VideoEntity.fps;
      if (info.fps) {
        _VideoEntity.VideoFps = info.fps;
      }
      this.config = {
        descript: {
          width: info.videoW,
          height: info.videoH,
          isEffect: info.isVapx,
          rgbFrame: info.rgbFrame,
          alphaFrame: info.aFrame,
          fps: info.fps,
          version: 0
        },
        effect: src,
        datas: frame
      };
    }
    if (this.op.fps)
      _VideoEntity.fps = this.op.fps;
    if (Animator.animationType !== "requestVideoFrameCallback" && _VideoEntity.fps > 20) {
      _VideoEntity.fps = 20;
    }
    await this.parseFromSrcAndOptions();
  }
  get isUseBitmap() {
    return !!self.createImageBitmap && this.op.useBitmap;
  }
  async loadImg(url) {
    var _a, _b;
    if (url.indexOf("http") === -1 && !isDataUrl(url)) {
      url = `${location.protocol}//${location.host}${url}`;
    }
    if (this.isUseBitmap && !isDataUrl(url)) {
      try {
        const blob = await fetch(url).then((r) => r.blob());
        const d = await self.createImageBitmap(blob, { imageOrientation: "flipY" });
        return d;
      } catch (e) {
        logger.error(e);
        (_b = (_a = this.op) == null ? void 0 : _a.onEnd) == null ? void 0 : _b.call(_a);
        return void 0;
      }
    }
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function() {
        resolve(img);
      };
      img.onerror = function(e) {
        logger.error("frame load fail:" + url);
        reject(void 0);
      };
      img.src = url;
    });
  }
  parseFromSrcAndOptions() {
    var _a;
    if (!((_a = this.config) == null ? void 0 : _a.effect))
      return;
    const effects = this.op.effects || {};
    return Promise.all(this.config.effect.map(async (item) => {
      const effectType = item[this.effectType];
      const effectTag = item[this.effectTag];
      if (this.effectTypes.txt.indexOf(effectType) > -1) {
        if (effects[effectTag]) {
          if (typeof effects[effectTag] === "string") {
            item.text = effects[effectTag];
          } else {
            item.text = effects[effectTag].text;
          }
          item.img = await this.makeTextImg(item, effects[effectTag]);
        }
      } else if (this.effectTypes.img.indexOf(effectType) > -1) {
        item.img = await this.makeImage(item, effects[effectTag]);
      }
    }));
  }
  async makeImage(item, url) {
    if (!this.ctx)
      return;
    const ctx = this.ctx;
    const w = item[this.effectWidth];
    const h = item[this.effectHeight];
    let img = null;
    if (url && url.length > 0) {
      img = await this.loadImg(url);
    }
    ctx.canvas.width = w;
    ctx.canvas.height = h;
    if (item.scaleMode && img) {
      switch (item.scaleMode) {
        case EScaleMode.aspectFill: {
          let adapt = 1;
          if (w / h > img.width / img.height) {
            adapt = w / img.width;
          } else {
            adapt = h / img.height;
          }
          const drawWidth = Math.round(img.width * adapt);
          const drawHeight = Math.round(img.height * adapt);
          const sx = -Math.round(Math.abs(drawWidth - w) / 2);
          const sy = -Math.round(Math.abs(drawHeight - h) / 2);
          ctx.save();
          if (!isDataUrl(url)) {
            ctx.translate(0, drawHeight);
            ctx.scale(1, -1);
          }
          ctx.drawImage(img, sx, sy, drawWidth, drawHeight);
          ctx.restore();
          return ctx.getImageData(0, 0, w, h);
        }
        case EScaleMode.aspectFit: {
          let adapt = 1;
          if (w / h < img.width / img.height) {
            adapt = w / img.width;
          } else {
            adapt = h / img.height;
          }
          const drawWidth = Math.round(img.width * adapt);
          const drawHeight = Math.round(img.height * adapt);
          const sx = -Math.round(Math.abs(drawWidth - w) / 2);
          const sy = -Math.round(Math.abs(drawHeight - h) / 2);
          ctx.save();
          if (!isDataUrl(url)) {
            ctx.translate(0, drawHeight);
            ctx.scale(1, -1);
          }
          ctx.drawImage(img, sx, sy, drawWidth, drawHeight);
          ctx.restore();
          return ctx.getImageData(0, 0, w, h);
        }
        case EScaleMode.scaleFill:
          return img;
        default:
          return img;
      }
    } else if (img) {
      return img;
    } else {
      ctx.clearRect(0, 0, w, h);
      return ctx.getImageData(0, 0, w, h);
    }
  }
  async makeTextImg(item, eOptions = {}) {
    if (!this.ctx)
      return;
    const ctx = this.ctx;
    if (eOptions.fontStyle)
      item.fontStyle = eOptions.fontStyle;
    if (eOptions.fontColor)
      item.fontColor = eOptions.fontColor;
    if (eOptions.fontSize)
      item.fontSize = eOptions.fontSize;
    const { fontStyle, fontColor, fontSize } = item;
    const w = item[this.effectWidth];
    const h = item[this.effectHeight];
    ctx.canvas.width = w;
    ctx.canvas.height = h;
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    const txt = item.text || "";
    const getFontStyle = (fontSize2) => {
      fontSize2 = fontSize2 || Math.min(w / txt.length, h - 8);
      const font = ["600", `${Math.round(fontSize2)}px`, "Microsoft YaHei"];
      if (fontStyle === "b") {
        font.unshift("bold");
      }
      return font.join(" ");
    };
    if (!fontStyle) {
      const fontStyle2 = getFontStyle(item.fontSize);
      ctx.font = fontStyle2;
      if (fontColor)
        ctx.fillStyle = fontColor;
    } else if (typeof fontStyle == "string") {
      ctx.font = fontStyle;
      if (fontColor)
        ctx.fillStyle = fontColor;
    } else if (typeof fontStyle == "object") {
      ctx.font = fontStyle["font"] || getFontStyle();
      ctx.fillStyle = fontStyle["color"] || fontColor;
    } else if (typeof fontStyle == "function") {
      ctx.font = getFontStyle(fontSize);
      if (fontColor)
        ctx.fillStyle = fontColor;
      fontStyle(null, ctx, item);
    }
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.fillText(txt, w / 2, h / 2);
    if (!!self.OffscreenCanvas && this.ofs instanceof OffscreenCanvas) {
      const blob = await this.ofs.convertToBlob();
      const bitmap = await self.createImageBitmap(blob, { imageOrientation: "flipY" });
      return bitmap;
    }
    return ctx.getImageData(0, 0, w, h);
  }
  getFrame(frame) {
    var _a;
    return (_a = this.config) == null ? void 0 : _a.datas.find((item) => {
      return item[this.frameIndex] === frame;
    });
  }
  getConfig(jsonUrl) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", jsonUrl, true);
      xhr.responseType = "json";
      xhr.onload = function() {
        if (xhr.status === 200 || xhr.status === 304 && xhr.response) {
          const res = xhr.response;
          resolve(res);
        } else {
          reject(new Error("http response invalid" + xhr.status));
        }
      };
      xhr.send();
    });
  }
};
let VideoEntity = _VideoEntity;
VideoEntity.fps = 30;
VideoEntity.VideoFps = 30;
function setStoreName(op) {
  const { videoUrl, effects, mode: mode2, container } = op;
  let storeName = isDataUrl(videoUrl) ? videoUrl.substring(22, 88) : videoUrl;
  if (effects) {
    const eUrl = Object.keys(effects).map((key) => key + "=" + effects[key]).join("&");
    storeName += eUrl.indexOf("?") > -1 ? "&" : "?";
    storeName += eUrl;
  }
  if (container && container.clientHeight) {
    storeName += `${storeName.indexOf("?") > -1 ? "&" : "?"}mode=${mode2}&height=${container.clientHeight}&width=${container.clientWidth}`;
  }
  storeName = storeName.replace(/\s+/g, "");
  return storeName;
}
const _MCache = class {
  constructor(op) {
    this.frameCacheCount = 5;
    this.requestAnimationFramePercent = 0.95;
    this.hasRequestAnimationFrame = false;
    if (!op.videoUrl || !op.useFrameCache)
      return;
    this.op = op;
    this.storeName = setStoreName(op);
    if (!_MCache.caches[this.storeName]) {
      logger.debug("[mCache]", "[\u5B9E\u4F8B\u5316]");
      _MCache.caches[this.storeName] = {};
      _MCache.cacheKeys.push(this.storeName);
    }
    if (typeof op.useFrameCache === "number" && op.useFrameCache > 0) {
      this.frameCacheCount = op.useFrameCache;
    }
    logger.debug(`[mcache]`, `[constructor] [animationType ${Animator.animationType}]`, `\u8BBE\u7F6E\u7F13\u5B58\u6570`, this.frameCacheCount, `\u7F13\u5B58\u89C6\u9891`, _MCache.cacheKeys);
    logger.debug(`[mcache]`, this.storeName, `\u5F53\u524D\u7F13\u5B58\u5E27\u6570 ${Object.keys(_MCache.caches[this.storeName] || {}).length}`);
  }
  async setup() {
    this.setAnimationStatus();
  }
  setAnimationStatus() {
    if (Animator.animationType !== "requestVideoFrameCallback" && Object.keys(_MCache.caches[this.storeName] || {}).length > 0) {
      this.hasRequestAnimationFrame = true;
    }
    logger.debug("[mCache]", "[setAnimationStatus]", "hasRequestAnimationFrame", this.hasRequestAnimationFrame);
  }
  isCache() {
    return Object.keys(_MCache.caches[this.storeName]).length > 0;
  }
  get() {
    return _MCache.caches[this.storeName];
  }
  set(d) {
    _MCache.caches[this.storeName] = d;
  }
  getFrame(frame) {
    if (this.hasRequestAnimationFrame) {
      return _MCache.caches[this.storeName] && _MCache.caches[this.storeName][frame] ? _MCache.caches[this.storeName][frame] : "skip";
    }
    return _MCache.caches[this.storeName] ? _MCache.caches[this.storeName][frame] : void 0;
  }
  setFrame(frame, d) {
    if (d && !_MCache.caches[this.storeName][frame] && !this.hasRequestAnimationFrame) {
      _MCache.caches[this.storeName][frame] = d;
    }
  }
  checkCache() {
    if (Animator.animationType !== "requestVideoFrameCallback") {
      let needCacheFrameCount = _MCache.videoDurationTime * VideoEntity.fps * this.requestAnimationFramePercent;
      needCacheFrameCount = Math.round(needCacheFrameCount);
      const cacheItem = _MCache.caches[this.storeName] || {};
      logger.debug("[mCache]", "[checkCache] \u5F53\u524D\u7F13\u5B58\u5E27\u6570", Object.keys(cacheItem).length, "\u9700\u8981\u7F13\u5B58\u5E27\u6570", needCacheFrameCount);
      if (cacheItem && Object.keys(cacheItem).length < needCacheFrameCount) {
        this.removeCacheItem(this.storeName);
        logger.debug("[mCache]", "[checkCache removeCacheItem]", this.storeName);
      }
    }
  }
  removeCache() {
    if (_MCache.cacheKeys.length > this.frameCacheCount) {
      const resetCount = _MCache.cacheKeys.length - this.frameCacheCount;
      for (let i = 1; i < resetCount; i++) {
        const key = _MCache.cacheKeys.shift();
        this.removeCacheItem(key);
        logger.debug("[mCache]", "[removeCache]", "\u8FBE\u5230\u89C6\u9891\u7F13\u5B58\u603B\u6570\u5220\u9664", key);
      }
    }
  }
  removeCacheItem(key) {
    if (_MCache.caches[key]) {
      delete _MCache.caches[key];
      _MCache.caches[key] = {};
    }
    const cacheKeyIndex = _MCache.cacheKeys.indexOf(key);
    if (cacheKeyIndex > -1) {
      _MCache.cacheKeys.splice(cacheKeyIndex, 1);
    }
  }
  videoSeekedEvent() {
    this.checkCache();
    this.setAnimationStatus();
  }
  destory() {
    logger.debug("[mCache]", "[destory]");
    this.removeCache();
    this.checkCache();
  }
};
let MCache = _MCache;
MCache.caches = {};
MCache.cacheKeys = [];
MCache.cachesOfs = {};
MCache.videoDurationTime = 0;
class RenderCache {
  constructor(canvas, op) {
    this.canvas = canvas;
    this.op = op;
    this.mCache = new MCache(this.op);
  }
  isCache() {
    return this.mCache.isCache();
  }
  setCache(frame) {
    if (!this.op.useFrameCache)
      return;
    this.createFramesCache(frame);
  }
  getCache(frame) {
    if (!this.op.useFrameCache)
      return void 0;
    return this.mCache.getFrame(frame);
  }
  destory() {
    this.mCache.destory();
  }
  async setup(videoDurationTime) {
    MCache.videoDurationTime = videoDurationTime;
    if (this.op.useFrameCache)
      await this.mCache.setup();
  }
  async createFramesCache(frame) {
    if (!this.canvas)
      return;
    if (this.op.useBitmap && self.createImageBitmap) {
      self.createImageBitmap(this.canvas).then((bitmap) => {
        this.mCache.setFrame(frame, bitmap);
      });
    } else if ("toDataURL" in this.canvas) {
      const ofsImageBase64 = this.canvas.toDataURL();
      const ofsImage = new Image();
      ofsImage.src = ofsImageBase64;
      this.mCache.setFrame(frame, ofsImage);
    }
  }
}
class WglRender {
  constructor(op) {
    this.isPlay = false;
    this.textureMap = {};
    this.currentFrame = -1;
    logger.debug("[Render In Webgl]");
    this.op = op;
    this.webgl = new Webgl(op);
    this.webgl.ofs.addEventListener("webglcontextlost", (e) => {
      logger.debug("[webglcontextlost]", e);
    });
    this.webgl.ofs.addEventListener("webglcontextrestored", () => {
      logger.debug("[webglcontextrestored]");
      this.webgl.initGlContext();
      this.initWebgl();
    });
    this.renderCache = new RenderCache(this.webgl.ofs, this.op);
    this.videoEntity = new VideoEntity(op);
  }
  videoSeekedEvent() {
    return this.renderCache.mCache.videoSeekedEvent();
  }
  async setup(video) {
    if (!video)
      throw new Error("video must support!");
    await this.renderCache.setup(video.duration);
    await this.videoEntity.setup();
    this.video = video;
    this.resizeCanvasToDisplaySize();
    this.initWebgl();
  }
  resizeCanvasToDisplaySize() {
    var _a;
    const descript = (_a = this.videoEntity.config) == null ? void 0 : _a.descript;
    const ofs = this.webgl.ofs;
    if (!descript) {
      if (!this.video)
        return;
      const vw = this.video.videoWidth ? this.video.videoWidth / 2 : 900;
      const vh = this.video.videoHeight ? this.video.videoHeight : 1e3;
      logger.debug("[resizeCanvasToDisplaySize]", vw, vh);
      ofs.width = vw;
      ofs.height = vh;
    } else {
      const [x, y, w, h] = descript.rgbFrame;
      ofs.width = w;
      ofs.height = h;
    }
    if (this.op.useOfsRender) {
      this.webgl.canvas.width = ofs.width;
      this.webgl.canvas.height = ofs.height;
    }
  }
  destroy() {
    this.webgl.destroy();
    this.videoEntity.destroy();
    this.renderCache.destory();
  }
  render(frame = 0) {
    var _a;
    if (!this.isPlay || !this.webgl.gl || !this.video || !this.program || this.currentFrame === frame)
      return;
    this.currentFrame = frame;
    const gl = this.webgl.gl;
    if (this.op.useFrameCache) {
      const { width, height } = this.webgl.canvas;
      const frameItem = this.renderCache.getCache(frame);
      if (frameItem === "skip")
        return;
      if (frameItem) {
        this.webgl.ctx.clearRect(0, 0, width, height);
        this.webgl.ctx.drawImage(frameItem, 0, 0, width, height, 0, 0, width, height);
        return;
      }
    }
    const descript = (_a = this.videoEntity.config) == null ? void 0 : _a.descript;
    if (descript) {
      const frameData = this.videoEntity.getFrame(frame);
      const frameItem = frameData ? frameData[this.videoEntity.data] : void 0;
      let posArr = [];
      const { width: vW, height: vH } = descript;
      if (frameItem) {
        frameItem.forEach((o) => {
          posArr[posArr.length] = +this.textureMap[o[this.videoEntity.effectId]];
          const [rgbX, rgbY] = descript.rgbFrame;
          const [x, y, w, h] = o[this.videoEntity.renderFrame];
          const [mX, mY, mW, mH] = o[this.videoEntity.outputFrame];
          const coord = this.computeCoord(x + rgbX, y + rgbY, w, h, vW, vH);
          const mCoord = this.computeCoord(mX, mY, mW, mH, vW, vH);
          posArr = posArr.concat(coord).concat(mCoord);
        });
      }
      const size = (gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 1) * this.webgl.PER_SIZE;
      posArr = posArr.concat(new Array(size - posArr.length).fill(0));
      this.imagePos = this.imagePos || gl.getUniformLocation(this.program, "image_pos");
      gl.uniform1fv(this.imagePos, new Float32Array(posArr));
    }
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, this.video);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    if (this.op.useOfsRender) {
      const { width, height } = this.webgl.canvas;
      this.webgl.ctx.clearRect(0, 0, width, height);
      this.webgl.ctx.drawImage(gl.canvas, 0, 0, width, height, 0, 0, width, height);
    }
    if (this.op.useFrameCache) {
      this.renderCache.setCache(frame);
    }
  }
  getScale() {
    let scaleX = 1;
    let scaleY = 1;
    if (this.video && this.op.mode) {
      const ofs = this.webgl.canvas ? this.webgl.canvas : this.webgl.ofs;
      const canvasAspect = ofs.clientWidth / ofs.clientHeight;
      const videoAspect = ofs.width / ofs.height;
      ofs.setAttribute("class", `e-video-${this.op.mode.toLocaleLowerCase()}`);
      switch (this.op.mode) {
        case "AspectFill":
        case "vertical":
          scaleY = 1;
          scaleX = videoAspect / canvasAspect;
          break;
        case "AspectFit":
        case "horizontal":
          scaleX = 1;
          scaleY = canvasAspect / videoAspect;
          break;
        case "contain":
          scaleY = 1;
          scaleX = videoAspect / canvasAspect;
          if (scaleX > 1) {
            scaleY = 1 / scaleX;
            scaleX = 1;
          }
          break;
        case "Fill":
        case "cover":
          scaleY = 1;
          scaleX = videoAspect / canvasAspect;
          if (scaleX < 1) {
            scaleY = 1 / scaleX;
            scaleX = 1;
          }
          break;
      }
    }
    return [scaleX, scaleY];
  }
  initWebgl() {
    if (!this.webgl.gl)
      return;
    const gl = this.webgl.gl;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.disable(gl.BLEND);
    gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
    const program = this.createProgram(gl);
    if (!program)
      return;
    this.program = program;
    this.initTexture(gl, program);
    this.initVideoTexture(gl, program);
    const scaleLocation = gl.getUniformLocation(program, "u_scale");
    const scale = this.getScale();
    gl.uniform2fv(scaleLocation, new Float32Array(scale));
  }
  initTexture(gl, program) {
    var _a;
    let i = 1;
    const effect = (_a = this.videoEntity.config) == null ? void 0 : _a.effect;
    if (effect) {
      for (const k in effect) {
        const r = effect[k];
        r.img && this.createTexture(gl, i, r.img);
        const sampler2 = gl.getUniformLocation(program, `u_image${i}`);
        gl.uniform1i(sampler2, i);
        this.textureMap[r[this.videoEntity.effectId]] = i++;
      }
      const dumpTexture = gl.createTexture();
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, dumpTexture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    }
    this.createTexture(gl, i);
    const sampler = gl.getUniformLocation(program, `u_image_video`);
    gl.uniform1i(sampler, i);
  }
  getRgbaPos() {
    var _a;
    const descript = (_a = this.videoEntity.config) == null ? void 0 : _a.descript;
    if (descript) {
      const { width: vW, height: vH } = descript;
      const [rgbX, rgbY, rgbW, rgbH] = descript.rgbFrame;
      const [aX, aY, aW, aH] = descript.alphaFrame;
      return { rgbX, rgbY, rgbW, rgbH, vW, vH, aX, aY, aW, aH };
    } else if (this.video) {
      const vW = this.video.videoWidth ? this.video.videoWidth : 1800;
      const vH = this.video.videoHeight ? this.video.videoHeight : 1e3;
      const stageW = vW / 2;
      const [rgbX, rgbY, rgbW, rgbH] = this.op.alphaDirection === "right" ? [0, 0, stageW, vH] : [stageW, 0, stageW, vH];
      const [aX, aY, aW, aH] = this.op.alphaDirection === "right" ? [stageW, 0, stageW, vH] : [0, 0, stageW, vH];
      return { rgbX, rgbY, rgbW, rgbH, vW, vH, aX, aY, aW, aH };
    }
  }
  initVideoTexture(gl, program) {
    const ver = [];
    const pos = this.getRgbaPos();
    if (!pos)
      return;
    const { rgbX, rgbY, rgbW, rgbH, vW, vH, aX, aY, aW, aH } = pos;
    const rgbCoord = this.computeCoord(rgbX, rgbY, rgbW, rgbH, vW, vH);
    const aCoord = this.computeCoord(aX, aY, aW, aH, vW, vH);
    ver.push(...[-1, 1, rgbCoord[0], rgbCoord[3], aCoord[0], aCoord[3]]);
    ver.push(...[1, 1, rgbCoord[1], rgbCoord[3], aCoord[1], aCoord[3]]);
    ver.push(...[-1, -1, rgbCoord[0], rgbCoord[2], aCoord[0], aCoord[2]]);
    ver.push(...[1, -1, rgbCoord[1], rgbCoord[2], aCoord[1], aCoord[2]]);
    const view = new Float32Array(ver);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, view, gl.STATIC_DRAW);
    const aPosition = gl.getAttribLocation(program, "a_position");
    gl.enableVertexAttribArray(aPosition);
    const aTexCoord = gl.getAttribLocation(program, "a_texCoord");
    gl.enableVertexAttribArray(aTexCoord);
    const aAlphaTexCoord = gl.getAttribLocation(program, "a_alpha_texCoord");
    gl.enableVertexAttribArray(aAlphaTexCoord);
    const size = view.BYTES_PER_ELEMENT;
    gl.vertexAttribPointer(aPosition, 2, gl.FLOAT, false, size * 6, 0);
    gl.vertexAttribPointer(aTexCoord, 2, gl.FLOAT, false, size * 6, size * 2);
    gl.vertexAttribPointer(aAlphaTexCoord, 2, gl.FLOAT, false, size * 6, size * 4);
  }
  createProgram(gl) {
    const vsSource = this.webgl.getVsSource();
    const fsSource = this.webgl.getFsSource();
    const vsShader = this.createShader(gl, gl.VERTEX_SHADER, vsSource);
    const fsShader = this.createShader(gl, gl.FRAGMENT_SHADER, fsSource);
    const program = gl.createProgram();
    if (!program || !vsShader || !fsShader)
      return;
    gl.attachShader(program, vsShader);
    gl.attachShader(program, fsShader);
    gl.linkProgram(program);
    gl.useProgram(program);
    return program;
  }
  createShader(gl, type, source) {
    const shader = gl.createShader(type);
    if (!shader)
      return;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      logger.error(gl.getShaderInfoLog(shader));
    }
    return shader;
  }
  computeCoord(x, y, w, h, vw, vh) {
    return [x / vw, (x + w) / vw, (vh - y - h) / vh, (vh - y) / vh];
  }
  createTexture(gl, index, imgData) {
    const texture = gl.createTexture();
    const textrueIndex = gl.TEXTURE0 + index;
    logger.debug("[createTexture]", textrueIndex, index, imgData);
    gl.activeTexture(textrueIndex);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    if (imgData) {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, imgData);
    }
    return texture;
  }
}
class Render2D {
  constructor(op) {
    this.isPlay = false;
    this.alphaCanvas = document.createElement("canvas");
    logger.debug("[Render In Canvas]");
    this.op = op;
    this.ofs = !!self.OffscreenCanvas && !!self.createImageBitmap ? new OffscreenCanvas(300, 300) : document.createElement("canvas");
    this.ctx = this.ofs.getContext("2d");
    this.renderCache = new RenderCache(this.ofs, this.op);
    this.videoEntity = new VideoEntity(op);
    this.alphaCtx = this.alphaCanvas.getContext("2d");
  }
  setSizeCanvas(canvas, resizeCanvas) {
    switch (resizeCanvas) {
      case "percent":
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        break;
      case "percentH":
        canvas.style.height = "100%";
        break;
      case "percentW":
        canvas.style.width = "100%";
        break;
    }
  }
  videoSeekedEvent() {
    logger.debug("[canvas2d][videoSeekedEvent]");
    return this.renderCache.mCache.videoSeekedEvent();
  }
  async setup(video) {
    var _a;
    if (!video)
      throw new Error("video must support!");
    await this.renderCache.setup(video.duration);
    this.video = video;
    await this.videoEntity.setup();
    const canvas = document.createElement("canvas");
    this.op.container.appendChild(canvas);
    canvas.width = video.videoWidth / 2;
    canvas.height = video.videoHeight;
    this.context = canvas.getContext("2d");
    this.canvas = canvas;
    this.ofs.width = video.videoWidth;
    this.ofs.height = video.videoHeight;
    const descript = (_a = this.videoEntity.config) == null ? void 0 : _a.descript;
    if (descript) {
      const [x, y, w, h] = descript.rgbFrame;
      canvas.width = w;
      canvas.height = h;
      this.ofs.width = descript.width;
      this.ofs.height = descript.height;
    }
    this.setSizeCanvas(canvas, this.op.resizeCanvas);
  }
  destroy() {
    this.clear();
    this.videoEntity.destroy();
    if (this.canvas) {
      this.canvas.remove();
      delete this.canvas;
      this.canvas = null;
    }
    if (this.ofs) {
      if (this.ofs instanceof HTMLCanvasElement) {
        this.ofs.remove();
      } else {
        this.ofs = void 0;
      }
    }
    if (this.alphaCanvas) {
      this.alphaCanvas.remove();
    }
  }
  clear() {
    var _a, _b;
    if (typeof this.video !== "undefined" && this.context)
      this.context.clearRect(0, 0, (_a = this.video) == null ? void 0 : _a.videoWidth, (_b = this.video) == null ? void 0 : _b.videoHeight);
  }
  render(frame = 0) {
    var _a;
    const { width: w, height: h } = this.canvas;
    if (this.op.useFrameCache) {
      const frameItem = this.renderCache.getCache(frame);
      if (frameItem === "skip")
        return;
      if (frameItem) {
        this.context.clearRect(0, 0, w, h);
        this.context.drawImage(frameItem, 0, 0, w, h, 0, 0, w, h);
        return;
      }
    }
    const descript = (_a = this.videoEntity.config) == null ? void 0 : _a.descript;
    if (descript) {
      this.renderMix(frame);
    } else {
      this.renderLR(frame);
    }
    this.context.clearRect(0, 0, w, h);
    this.context.drawImage(this.ofs, 0, 0, w, h, 0, 0, w, h);
    if (this.op.useFrameCache) {
      this.renderCache.setCache(frame);
    }
  }
  scaleImageData(imageData, scale) {
    const ctx = this.alphaCtx;
    const scaled = ctx.createImageData(imageData.width * scale, imageData.height * scale);
    const subLine = ctx.createImageData(scale, 1).data;
    for (let row = 0; row < imageData.height; row++) {
      for (let col = 0; col < imageData.width; col++) {
        const sourcePixel = imageData.data.subarray((row * imageData.width + col) * 4, (row * imageData.width + col) * 4 + 4);
        for (let x = 0; x < scale; x++)
          subLine.set(sourcePixel, x * 4);
        for (let y = 0; y < scale; y++) {
          const destRow = row * scale + y;
          const destCol = col * scale;
          scaled.data.set(subLine, (destRow * scaled.width + destCol) * 4);
        }
      }
    }
    return scaled;
  }
  renderMix(frame = 0) {
    var _a;
    const descript = (_a = this.videoEntity.config) == null ? void 0 : _a.descript;
    if (!this.ctx || !this.isPlay || typeof this.video === "undefined" || !descript)
      return;
    const [x, y, w, h] = descript.rgbFrame;
    const [ax, ay, aw, ah] = descript.alphaFrame;
    const vw = this.video.videoWidth;
    const vh = this.video.videoHeight;
    this.ctx.drawImage(this.video, 0, 0, vw, vh, 0, 0, vw, vh);
    const colorImageData = this.ctx.getImageData(x, y, w, h);
    let alpathImageData = this.ctx.getImageData(ax, ay, aw, ah);
    alpathImageData = this.scaleImageData(alpathImageData, w / aw);
    for (let i = 3, len = colorImageData == null ? void 0 : colorImageData.data.length; i < len; i += 4) {
      colorImageData.data[i] = alpathImageData.data[i - 1];
    }
    this.ctx.clearRect(0, 0, w, h);
    this.ctx.putImageData(colorImageData, 0, 0, 0, 0, w, h);
  }
  renderLR(frame = 0) {
    if (!this.ctx || !this.isPlay || typeof this.video === "undefined")
      return;
    const vw = this.video.videoWidth;
    const vh = this.video.videoHeight;
    const stageWidth = vw / 2;
    const stageHeight = vh;
    this.ctx.drawImage(this.video, 0, 0, vw, vh, 0, 0, vw, vh);
    if (this.op.alphaDirection === "left") {
      const colorImageData = this.ctx.getImageData(stageWidth, 0, stageWidth, stageHeight);
      const alpathImageData = this.ctx.getImageData(0, 0, stageWidth, stageHeight);
      for (let i = 3, len = colorImageData == null ? void 0 : colorImageData.data.length; i < len; i += 4) {
        colorImageData.data[i] = alpathImageData.data[i - 1];
      }
      this.ctx.putImageData(colorImageData, 0, 0, 0, 0, stageWidth, stageHeight);
    } else {
      const alpathImageData = this.ctx.getImageData(stageWidth, 0, stageWidth, stageHeight);
      const colorImageData = this.ctx.getImageData(0, 0, stageWidth, stageHeight);
      for (let i = 3, len = colorImageData == null ? void 0 : colorImageData.data.length; i < len; i += 4) {
        colorImageData.data[i] = alpathImageData.data[i - 1];
      }
      this.ctx.putImageData(colorImageData, 0, 0, 0, 0, stageWidth, stageHeight);
    }
  }
}
Render2D.webgl = { version: "canvas2d" };
var videoEvents = [
  "playing",
  "pause",
  "ended",
  "progress",
  "loadstart",
  "stop",
  "loadeddata",
  "ratechange",
  "abort",
  "emptied",
  "error",
  "mozaudioavailable",
  "stalled",
  "suspend",
  "play",
  "waiting",
  "canplay",
  "canplaythrough",
  "seeked",
  "seeking"
];
const BTYPE = Object.freeze({
  UNCOMPRESSED: 0,
  FIXED: 1,
  DYNAMIC: 2
});
const LENGTH_EXTRA_BIT_LEN = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0
];
const LENGTH_EXTRA_BIT_BASE = [
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258
];
const DISTANCE_EXTRA_BIT_BASE = [
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577
];
const DISTANCE_EXTRA_BIT_LEN = [
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13
];
const CODELEN_VALUES = [
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
];
function generateHuffmanTable(codelenValues) {
  const codelens = Object.keys(codelenValues);
  let codelen = 0;
  let codelenMax = 0;
  let codelenMin = Number.MAX_SAFE_INTEGER;
  codelens.forEach((key) => {
    codelen = Number(key);
    if (codelenMax < codelen) {
      codelenMax = codelen;
    }
    if (codelenMin > codelen) {
      codelenMin = codelen;
    }
  });
  let code = 0;
  let values;
  const bitlenTables = {};
  for (let bitlen = codelenMin; bitlen <= codelenMax; bitlen++) {
    values = codelenValues[bitlen];
    if (values === void 0) {
      values = [];
    }
    values.sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });
    const table = {};
    values.forEach((value) => {
      table[code] = value;
      code++;
    });
    bitlenTables[bitlen] = table;
    code <<= 1;
  }
  return bitlenTables;
}
function makeFixedHuffmanCodelenValues() {
  const codelenValues = {};
  codelenValues[7] = [];
  codelenValues[8] = [];
  codelenValues[9] = [];
  for (let i = 0; i <= 287; i++) {
    i <= 143 ? codelenValues[8].push(i) : i <= 255 ? codelenValues[9].push(i) : i <= 279 ? codelenValues[7].push(i) : codelenValues[8].push(i);
  }
  return codelenValues;
}
class BitReadStream {
  constructor(buffer, offset = 0) {
    this.nowBitsLength = 0;
    this.isEnd = false;
    this.buffer = buffer;
    this.bufferIndex = offset;
    this.nowBits = buffer[offset];
    this.nowBitsLength = 8;
  }
  read() {
    if (this.isEnd) {
      throw new Error("Lack of data length");
    }
    const bit = this.nowBits & 1;
    if (this.nowBitsLength > 1) {
      this.nowBitsLength--;
      this.nowBits >>= 1;
    } else {
      this.bufferIndex++;
      if (this.bufferIndex < this.buffer.length) {
        this.nowBits = this.buffer[this.bufferIndex];
        this.nowBitsLength = 8;
      } else {
        this.nowBitsLength = 0;
        this.isEnd = true;
      }
    }
    return bit;
  }
  readRange(length) {
    while (this.nowBitsLength <= length) {
      this.nowBits |= this.buffer[++this.bufferIndex] << this.nowBitsLength;
      this.nowBitsLength += 8;
    }
    const bits = this.nowBits & (1 << length) - 1;
    this.nowBits >>>= length;
    this.nowBitsLength -= length;
    return bits;
  }
  readRangeCoded(length) {
    let bits = 0;
    for (let i = 0; i < length; i++) {
      bits <<= 1;
      bits |= this.read();
    }
    return bits;
  }
}
class Uint8WriteStream {
  constructor(extendedSize) {
    this.index = 0;
    this.buffer = new Uint8Array(extendedSize);
    this.length = extendedSize;
    this._extendedSize = extendedSize;
  }
  write(value) {
    if (this.length <= this.index) {
      this.length += this._extendedSize;
      const newBuffer = new Uint8Array(this.length);
      const nowSize = this.buffer.length;
      for (let i = 0; i < nowSize; i++) {
        newBuffer[i] = this.buffer[i];
      }
      this.buffer = newBuffer;
    }
    this.buffer[this.index] = value;
    this.index++;
  }
}
const FIXED_HUFFMAN_TABLE = generateHuffmanTable(makeFixedHuffmanCodelenValues());
function inflate$1(input, offset = 0) {
  const buffer = new Uint8WriteStream(input.length * 10);
  const stream = new BitReadStream(input, offset);
  let bFinal = 0;
  let bType = 0;
  while (bFinal !== 1) {
    bFinal = stream.readRange(1);
    bType = stream.readRange(2);
    if (bType === BTYPE.UNCOMPRESSED) {
      inflateUncompressedBlock(stream, buffer);
    } else if (bType === BTYPE.FIXED) {
      inflateFixedBlock(stream, buffer);
    } else if (bType === BTYPE.DYNAMIC) {
      inflateDynamicBlock(stream, buffer);
    } else {
      throw new Error("Not supported BTYPE : " + bType);
    }
    if (bFinal === 0 && stream.isEnd) {
      throw new Error("Data length is insufficient");
    }
  }
  return buffer.buffer.subarray(0, buffer.index);
}
function inflateUncompressedBlock(stream, buffer) {
  if (stream.nowBitsLength < 8) {
    stream.readRange(stream.nowBitsLength);
  }
  const LEN = stream.readRange(8) | stream.readRange(8) << 8;
  const NLEN = stream.readRange(8) | stream.readRange(8) << 8;
  if (LEN + NLEN !== 65535) {
    throw new Error("Data is corrupted");
  }
  for (let i = 0; i < LEN; i++) {
    buffer.write(stream.readRange(8));
  }
}
function inflateFixedBlock(stream, buffer) {
  const tables = FIXED_HUFFMAN_TABLE;
  const codelens = Object.keys(tables);
  let codelen = 0;
  let codelenMax = 0;
  let codelenMin = Number.MAX_SAFE_INTEGER;
  codelens.forEach((key) => {
    codelen = Number(key);
    if (codelenMax < codelen) {
      codelenMax = codelen;
    }
    if (codelenMin > codelen) {
      codelenMin = codelen;
    }
  });
  let code = 0;
  let value;
  let repeatLengthCode;
  let repeatLengthValue;
  let repeatLengthExt;
  let repeatDistanceCode;
  let repeatDistanceValue;
  let repeatDistanceExt;
  let repeatStartIndex;
  while (!stream.isEnd) {
    value = void 0;
    codelen = codelenMin;
    code = stream.readRangeCoded(codelenMin);
    while (true) {
      value = tables[codelen][code];
      if (value !== void 0) {
        break;
      }
      if (codelenMax <= codelen) {
        throw new Error("Data is corrupted");
      }
      codelen++;
      code <<= 1;
      code |= stream.read();
    }
    if (value < 256) {
      buffer.write(value);
      continue;
    }
    if (value === 256) {
      break;
    }
    repeatLengthCode = value - 257;
    repeatLengthValue = LENGTH_EXTRA_BIT_BASE[repeatLengthCode];
    repeatLengthExt = LENGTH_EXTRA_BIT_LEN[repeatLengthCode];
    if (0 < repeatLengthExt) {
      repeatLengthValue += stream.readRange(repeatLengthExt);
    }
    repeatDistanceCode = stream.readRangeCoded(5);
    repeatDistanceValue = DISTANCE_EXTRA_BIT_BASE[repeatDistanceCode];
    repeatDistanceExt = DISTANCE_EXTRA_BIT_LEN[repeatDistanceCode];
    if (0 < repeatDistanceExt) {
      repeatDistanceValue += stream.readRange(repeatDistanceExt);
    }
    repeatStartIndex = buffer.index - repeatDistanceValue;
    for (let i = 0; i < repeatLengthValue; i++) {
      buffer.write(buffer.buffer[repeatStartIndex + i]);
    }
  }
}
function inflateDynamicBlock(stream, buffer) {
  const HLIT = stream.readRange(5) + 257;
  const HDIST = stream.readRange(5) + 1;
  const HCLEN = stream.readRange(4) + 4;
  let codelenCodelen = 0;
  const codelenCodelenValues = {};
  for (let i = 0; i < HCLEN; i++) {
    codelenCodelen = stream.readRange(3);
    if (codelenCodelen === 0) {
      continue;
    }
    if (!codelenCodelenValues[codelenCodelen]) {
      codelenCodelenValues[codelenCodelen] = [];
    }
    codelenCodelenValues[codelenCodelen].push(CODELEN_VALUES[i]);
  }
  const codelenHuffmanTables = generateHuffmanTable(codelenCodelenValues);
  const codelenCodelens = Object.keys(codelenHuffmanTables);
  let codelenCodelenMax = 0;
  let codelenCodelenMin = Number.MAX_SAFE_INTEGER;
  codelenCodelens.forEach((key) => {
    codelenCodelen = Number(key);
    if (codelenCodelenMax < codelenCodelen) {
      codelenCodelenMax = codelenCodelen;
    }
    if (codelenCodelenMin > codelenCodelen) {
      codelenCodelenMin = codelenCodelen;
    }
  });
  const dataCodelenValues = {};
  const distanceCodelenValues = {};
  let codelenCode = 0;
  let runlengthCode;
  let repeat = 0;
  let codelen = 0;
  const codesNumber = HLIT + HDIST;
  for (let i = 0; i < codesNumber; ) {
    runlengthCode = void 0;
    codelenCodelen = codelenCodelenMin;
    codelenCode = stream.readRangeCoded(codelenCodelenMin);
    while (true) {
      runlengthCode = codelenHuffmanTables[codelenCodelen][codelenCode];
      if (runlengthCode !== void 0) {
        break;
      }
      if (codelenCodelenMax <= codelenCodelen) {
        throw new Error("Data is corrupted");
      }
      codelenCodelen++;
      codelenCode <<= 1;
      codelenCode |= stream.read();
    }
    if (runlengthCode === 16) {
      repeat = 3 + stream.readRange(2);
    } else if (runlengthCode === 17) {
      repeat = 3 + stream.readRange(3);
      codelen = 0;
    } else if (runlengthCode === 18) {
      repeat = 11 + stream.readRange(7);
      codelen = 0;
    } else {
      repeat = 1;
      codelen = runlengthCode;
    }
    if (codelen <= 0) {
      i += repeat;
    } else {
      while (repeat) {
        if (i < HLIT) {
          if (!dataCodelenValues[codelen]) {
            dataCodelenValues[codelen] = [];
          }
          dataCodelenValues[codelen].push(i++);
        } else {
          if (!distanceCodelenValues[codelen]) {
            distanceCodelenValues[codelen] = [];
          }
          distanceCodelenValues[codelen].push(i++ - HLIT);
        }
        repeat--;
      }
    }
  }
  const dataHuffmanTables = generateHuffmanTable(dataCodelenValues);
  const distanceHuffmanTables = generateHuffmanTable(distanceCodelenValues);
  const dataCodelens = Object.keys(dataHuffmanTables);
  let dataCodelen = 0;
  let dataCodelenMax = 0;
  let dataCodelenMin = Number.MAX_SAFE_INTEGER;
  dataCodelens.forEach((key) => {
    dataCodelen = Number(key);
    if (dataCodelenMax < dataCodelen) {
      dataCodelenMax = dataCodelen;
    }
    if (dataCodelenMin > dataCodelen) {
      dataCodelenMin = dataCodelen;
    }
  });
  const distanceCodelens = Object.keys(distanceHuffmanTables);
  let distanceCodelen = 0;
  let distanceCodelenMax = 0;
  let distanceCodelenMin = Number.MAX_SAFE_INTEGER;
  distanceCodelens.forEach((key) => {
    distanceCodelen = Number(key);
    if (distanceCodelenMax < distanceCodelen) {
      distanceCodelenMax = distanceCodelen;
    }
    if (distanceCodelenMin > distanceCodelen) {
      distanceCodelenMin = distanceCodelen;
    }
  });
  let dataCode = 0;
  let data;
  let repeatLengthCode;
  let repeatLengthValue;
  let repeatLengthExt;
  let repeatDistanceCode;
  let repeatDistanceValue;
  let repeatDistanceExt;
  let repeatDistanceCodeCodelen;
  let repeatDistanceCodeCode;
  let repeatStartIndex;
  while (!stream.isEnd) {
    data = void 0;
    dataCodelen = dataCodelenMin;
    dataCode = stream.readRangeCoded(dataCodelenMin);
    while (true) {
      data = dataHuffmanTables[dataCodelen][dataCode];
      if (data !== void 0) {
        break;
      }
      if (dataCodelenMax <= dataCodelen) {
        throw new Error("Data is corrupted");
      }
      dataCodelen++;
      dataCode <<= 1;
      dataCode |= stream.read();
    }
    if (data < 256) {
      buffer.write(data);
      continue;
    }
    if (data === 256) {
      break;
    }
    repeatLengthCode = data - 257;
    repeatLengthValue = LENGTH_EXTRA_BIT_BASE[repeatLengthCode];
    repeatLengthExt = LENGTH_EXTRA_BIT_LEN[repeatLengthCode];
    if (0 < repeatLengthExt) {
      repeatLengthValue += stream.readRange(repeatLengthExt);
    }
    repeatDistanceCode = void 0;
    repeatDistanceCodeCodelen = distanceCodelenMin;
    repeatDistanceCodeCode = stream.readRangeCoded(distanceCodelenMin);
    while (true) {
      repeatDistanceCode = distanceHuffmanTables[repeatDistanceCodeCodelen][repeatDistanceCodeCode];
      if (repeatDistanceCode !== void 0) {
        break;
      }
      if (distanceCodelenMax <= repeatDistanceCodeCodelen) {
        throw new Error("Data is corrupted");
      }
      repeatDistanceCodeCodelen++;
      repeatDistanceCodeCode <<= 1;
      repeatDistanceCodeCode |= stream.read();
    }
    repeatDistanceValue = DISTANCE_EXTRA_BIT_BASE[repeatDistanceCode];
    repeatDistanceExt = DISTANCE_EXTRA_BIT_LEN[repeatDistanceCode];
    if (0 < repeatDistanceExt) {
      repeatDistanceValue += stream.readRange(repeatDistanceExt);
    }
    repeatStartIndex = buffer.index - repeatDistanceValue;
    for (let i = 0; i < repeatLengthValue; i++) {
      buffer.write(buffer.buffer[repeatStartIndex + i]);
    }
  }
}
/**
 * @license Copyright (c) 2018 zprodev
 */
function inflate(input) {
  const stream = new BitReadStream(input);
  const CM = stream.readRange(4);
  if (CM !== 8) {
    throw new Error("Not compressed by deflate");
  }
  stream.readRange(4);
  stream.readRange(5);
  stream.readRange(1);
  stream.readRange(2);
  return inflate$1(input, 2);
}
const yyExp = new RegExp("yyeffectmp4json\\[\\[(.*?)\\]\\]yyeffectmp4json");
class Parser {
  constructor() {
    this.exp = new RegExp("eJzt3U1v20gMgOH", "g");
  }
  getdata(resultStr) {
    const raw = atob(resultStr.slice(resultStr.indexOf(",") + 1));
    try {
      const mc = raw.match(yyExp);
      if (!mc)
        return void 0;
      const zlibBase64String = mc[1];
      const u8 = this.inflate(zlibBase64String);
      let d = this.unit8Tostring(u8);
      d = JSON.parse(d);
      logger.debug("[ParserGetData]", d);
      return d;
    } catch (e) {
      logger.warn(e);
      return void 0;
    }
  }
  base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  unit8Tostring(u8data) {
    return new TextDecoder().decode(u8data);
  }
  inflate(str) {
    const u8data = inflate(new Uint8Array(this.base64ToArrayBuffer(str)));
    return u8data;
  }
}
var parser = new Parser();
class DB {
  constructor({
    name,
    version: version2,
    storeName
  } = { name: "e-video", version: 1, storeName: "video" }) {
    logger.debug("[DBCache] DB", name, version2, storeName);
    this.storeName = storeName;
    this.dbPromise = new Promise((resolve, reject) => {
      if (self.indexedDB !== void 0) {
        const request = self.indexedDB.open(name, version2);
        request.onerror = (error) => {
          logger.warn(`IndexedDB open fail, ${error.type}`);
          return resolve(void 0);
        };
        request.onsuccess = () => resolve(request.result);
        request.onupgradeneeded = (e) => {
          const db2 = request.result;
          if (e.oldVersion && e.oldVersion < e.newVersion) {
            logger.debug("[DB] deleteObjectStore");
            db2.deleteObjectStore(storeName);
          }
          db2.createObjectStore(storeName);
        };
      } else {
        reject("IndexedDB not supported");
      }
    });
  }
  async find(id) {
    return await this.dbPromise.then(async (db2) => await new Promise((resolve, reject) => {
      const tx = db2.transaction([this.storeName], "readonly");
      const request = tx.objectStore(this.storeName).get(id);
      request.onsuccess = () => {
        resolve(request.result);
      };
      request.onerror = () => reject(new Error("Find Error"));
    }));
  }
  async insert(id, data) {
    return await this.dbPromise.then(async (db2) => await new Promise((resolve, reject) => {
      const tx = db2.transaction([this.storeName], "readwrite");
      const request = tx.objectStore(this.storeName).put(data, id);
      tx.oncomplete = () => resolve();
      request.onerror = () => reject(new Error("Insert Error"));
    }));
  }
  async delete(id) {
    return await this.dbPromise.then(async (db2) => await new Promise((resolve, reject) => {
      const tx = db2.transaction([this.storeName], "readwrite");
      const request = tx.objectStore(this.storeName).delete(id);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(new Error("Delete Error"));
    }));
  }
}
class DBCache {
  constructor() {
    this.useIndexDB = true;
  }
  set IndexDB(isUse) {
    this.useIndexDB = isUse;
    logger.debug("[DBCache] IndexDB", this.useIndexDB);
  }
  model() {
    if (typeof window !== "undefined" && this.useIndexDB) {
      if (!this.db) {
        logger.debug("[DBCache] new DB");
        this.db = new DB();
      }
      return this.db;
    } else {
      return this;
    }
  }
  async find(id) {
  }
  async insert(id, data) {
  }
  async delete(id) {
  }
}
var db = new DBCache();
const ua = navigator.userAgent.toLowerCase();
const isWeixin = ua.indexOf("micromessenger") > -1;
const isBaidu = /baidu/.test(ua);
const isIOS = /iphone|ipad|ipod/i.test(ua);
const isMac = /macintosh/i.test(ua);
const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
const isApple = isIOS || isMac;
ua.indexOf("mqqbrowser") > -1;
const isAndroid = /android|adr/i.test(ua);
const isUCBrowser = ua.indexOf("ucbrowser") > -1;
const isQuark = ua.indexOf("quark") > -1;
const polyfill = {
  baidu: isBaidu,
  weixin: isWeixin,
  apple: isApple,
  ios: isIOS,
  android: isAndroid,
  uc: isUCBrowser,
  quark: isQuark,
  mac: isMac,
  safari: isSafari
};
let wxIsReady = false;
const wxReady = () => new Promise((resolve) => {
  document.addEventListener("WeixinJSBridgeReady", () => {
    logger.debug("WeixinJSBridgeReady");
    wxIsReady = true;
    resolve(wxIsReady);
  });
});
let tips;
const clickPlayBtn = (container, video) => {
  if (!tips) {
    tips = document.createElement("div");
    tips.innerText = "Click To Play";
    tips.style.textAlign = "center";
    tips.style.background = "rgba(255,255,255,0.7)";
    tips.style.position = "absolute";
    tips.style.zIndex = "99999";
    tips.style.top = "50%";
    tips.style.left = "50%";
    tips.style.padding = "10px";
    tips.style.transform = "translate(-50%,-50%)";
    tips.style.cursor = "pointer";
    tips.style["border-radius"] = "5px";
    container.appendChild(tips);
  }
  tips.onclick = () => {
    video.play();
    tips.style.display = "none";
  };
};
class EVideo {
  constructor(op) {
    this.eventsFn = {};
    this.isPlay = false;
    this.setPlay = (isPlay) => {
      if (this.renderer) {
        this.renderer.isPlay = isPlay;
        this.animator.isPlay = isPlay;
        this.isPlay = isPlay;
      }
    };
    this.videoEvent = (e) => {
      logger.debug(`[${e.type}]:`, e);
      this.eventsFn[e.type] && this.eventsFn[e.type]();
    };
    this.videoVisbility = () => {
      logger.debug("[visibilitychange]", document.hidden);
      if (document.hidden) {
        logger.debug("[visibilitychange] pause");
        this.video.pause();
      } else {
        logger.debug("[visibilitychange] play");
        this.video.play();
      }
    };
    if (!op.container)
      throw new Error("container is need!");
    if (!op.videoUrl)
      throw new Error("videoUrl is need!");
    this.op = op;
    this.video = this.videoCreate();
    this.animator = new Animator(this.video, this.op);
    if (this.op.renderType === "canvas2d") {
      this.renderer = new Render2D(this.op);
      this.renderType = "canvas2d";
    } else {
      this.renderer = new WglRender(this.op);
      this.renderType = "webgl";
    }
    if (Webgl.version === "canvas2d") {
      this.renderer = new Render2D(this.op);
      this.renderType = "canvas2d";
    }
    db.IndexDB = this.op.useVideoDBCache;
  }
  async setup() {
    var _a, _b;
    try {
      logger.debug("[=== e-video setup ===]");
      await this.videoLoad();
      await this.renderer.setup(this.video);
      await this.animator.setup();
      this.animator.onUpdate = (frame) => {
        this.renderer.render(frame);
      };
      logger.debug("[setup]", Animator.animationType, Webgl.version);
      if (Webgl.version !== "canvas2d" && this.op.renderType !== "canvas2d") {
        const render = this.renderer;
        const isCache = this.op.useFrameCache ? render.renderCache.isCache() : false;
        if (Animator.animationType !== "requestVideoFrameCallback" && !this.op.showVideo && !isCache) {
          const video = this.video;
          video.style.position = "fixed";
          video.style.opacity = "0.1";
          video.style.left = "0";
          video.style.top = "0";
          video.style.visibility = "visible";
          video.style.width = "2px";
          video.style.height = "2px";
          video.style.pointerEvents = "none";
          video.style.userSelect = "none";
        }
      }
    } catch (e) {
      (_a = this.onEnd) == null ? void 0 : _a.call(this);
      (_b = this.onError) == null ? void 0 : _b.call(this, e);
      this.destroy();
      logger.error(e);
    }
  }
  isDestoryed() {
    logger.debug("player is destoryed!");
  }
  start() {
    if (!this.renderer)
      return this.isDestoryed();
    this.startEvent();
  }
  clickToPlay() {
    if (this.op.onRequestClickPlay) {
      this.op.onRequestClickPlay(this.op.container, this.video);
    } else {
      clickPlayBtn(this.op.container, this.video);
    }
  }
  startEvent() {
    var _a, _b;
    if (this.renderer.isPlay === true)
      return;
    this.setPlay(true);
    this.animator.start();
    const videoPromise = this.video.play();
    if (videoPromise) {
      videoPromise.then(() => {
        logger.debug(`${this.op.mute === false ? "\u58F0\u97F3\u64AD\u653E" : "\u9759\u97F3\u64AD\u653E"}`);
      }).catch((e) => {
        var _a2, _b2;
        if (polyfill.safari && polyfill.mac) {
          logger.debug("\u5207\u6362\u5230\u9759\u97F3\u64AD\u653E", this.op.videoUrl);
          this.video.muted = true;
          this.video.play().catch((e2) => {
            var _a3, _b3;
            logger.debug(e2);
            (_b3 = (_a3 = this.op) == null ? void 0 : _a3.onError) == null ? void 0 : _b3.call(_a3, e2);
          });
          return;
        }
        logger.debug(`\u5207\u6362\u5230\u9759\u97F3\u64AD\u653E`, this.op.videoUrl, e);
        this.clickToPlay();
        if ((e == null ? void 0 : e.code) === 0 && (e == null ? void 0 : e.name) === EPlayError.NotAllowedError) {
          (_b2 = (_a2 = this.op) == null ? void 0 : _a2.onError) == null ? void 0 : _b2.call(_a2, {
            playError: EPlayError.NotAllowedError,
            video: this.video,
            playStep: EPlayStep.muted
          });
        }
      });
    } else {
      (_b = (_a = this.op) == null ? void 0 : _a.onEnd) == null ? void 0 : _b.call(_a);
    }
  }
  stop() {
    if (!this.renderer)
      return this.isDestoryed();
    if (this.renderer.isPlay === false)
      return;
    this.setPlay(false);
    this.animator.stop();
    this.video.pause();
  }
  videoCreate() {
    const videoID = this.op.videoID || getVIdeoId(this.op.videoUrl, polyfill.weixin);
    logger.debug("[videoID]", videoID);
    const videoElm = document.getElementById(videoID);
    let video;
    if (videoElm instanceof HTMLVideoElement) {
      video = videoElm;
    } else {
      video = document.createElement("video");
      video.setAttribute("id", videoID);
      document.body.appendChild(video);
    }
    if (!this.op.showVideo) {
      video.style.position = "fixed";
      video.style.opacity = "0";
      video.style.left = "-9999px";
      video.style.top = "9999px";
      video.style.visibility = "hidden";
    }
    video.muted = typeof this.op.mute !== "undefined" ? this.op.mute : true;
    video.loop = typeof this.op.loop !== "undefined" ? this.op.loop : true;
    video.crossOrigin = "anonymous";
    video.autoplay = true;
    video.setAttribute("preload", "auto");
    video.setAttribute("x5-playsinline", "true");
    video.setAttribute("playsinline", "true");
    video.setAttribute("webkit-playsinline", "true");
    video.setAttribute("x-webkit-airplay", "allow");
    video.setAttribute("t7-video-player-type", "h5");
    video.setAttribute("x5-video-player-type", "h5");
    if (polyfill.quark || polyfill.uc)
      video.setAttribute("renderer", "standard");
    return video;
  }
  async videoAddEvents() {
    const video = this.video;
    this.eventsFn.canplaythrough = () => {
      logger.debug("canplaythrough paused", video.paused);
      if (video.paused) {
        const videoPromise = video.play();
        if (videoPromise)
          videoPromise.catch((e) => {
            var _a, _b;
            logger.warn(`play() error canplaythrough to play`, e.code, e.message, e.name);
            if ((e == null ? void 0 : e.code) === 0 && (e == null ? void 0 : e.name) === EPlayError.NotAllowedError) {
              (_b = (_a = this.op) == null ? void 0 : _a.onError) == null ? void 0 : _b.call(_a, {
                playError: EPlayError.NotAllowedError,
                video: this.video,
                playStep: EPlayStep.canplaythrough
              });
            }
          });
      }
    };
    this.eventsFn.stalled = () => {
      this.video.load();
    };
    this.eventsFn.playing = () => {
      this.start();
      this.onStart && this.onStart();
    };
    this.eventsFn.pause = () => {
      this.stop();
      this.onPause && this.onPause();
    };
    this.eventsFn.resume = () => {
      this.start();
      this.onResume && this.onResume();
    };
    this.eventsFn.ended = () => {
      this.destroy();
      this.onEnd && this.onEnd();
    };
    this.eventsFn.progress = () => {
      this.onProcess && this.onProcess();
    };
    this.eventsFn.stop = () => {
      this.onStop && this.onStop();
    };
    this.eventsFn.seeked = () => {
      this.renderer.videoSeekedEvent();
    };
    this.eventsFn.error = (e) => {
      this.onError && this.onError(e);
    };
    videoEvents.map((name) => {
      video.addEventListener(name, this.videoEvent, false);
    });
    document.addEventListener("visibilitychange", this.videoVisbility, false);
    return new Promise((resolve) => {
      video.addEventListener("loadedmetadata", (e) => {
        this.videoEvent(e);
        resolve(e);
        logger.debug("[video loadedmetadata]", video.videoWidth, video.videoHeight, video.src.length);
      });
    });
  }
  async videoLoad() {
    const video = this.video;
    if (this.op.usePrefetch) {
      const url = await this.prefetch();
      video.src = url;
      logger.debug("[prefetch url]", url.length);
    } else {
      video.src = this.op.videoUrl;
      logger.debug("[prefetch url]", this.op.videoUrl.length);
    }
    video.load();
    logger.debug("[video load]");
    await this.videoAddEvents();
  }
  removeVideoEvent() {
    videoEvents.map((name) => {
      this.video.removeEventListener(name, this.videoEvent, false);
    });
    document.removeEventListener("visibilitychange", this.videoVisbility, false);
    if (this.video) {
      this.video.pause();
      if (!polyfill.weixin && !this.op.videoID) {
        this.video.src = "";
        this.video.load();
        this.video.remove();
      }
    }
  }
  revokeObjectURL(tips2) {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
      logger.debug(`[${tips2} revokeObjectURL]`, this.blobUrl.length);
      this.blobUrl = void 0;
    }
  }
  createObjectURL(blob) {
    logger.debug("[createObjectURL]");
    return URL.createObjectURL(blob);
  }
  destroy() {
    if (!this.renderer)
      return this.isDestoryed();
    this.revokeObjectURL("destroy");
    logger.debug("[destroy]");
    this.setPlay(false);
    this.removeVideoEvent();
    this.renderer.destroy();
    this.animator.destroy();
    this.renderer = void 0;
    this.animator = void 0;
    this.version = void 0;
  }
  async checkVideoCache() {
    try {
      const d = await db.model().find(this.op.videoUrl);
      if (d) {
        const { blob, data } = d;
        if (data)
          this.renderer.videoEntity.setConfig(data);
        logger.debug("[checkVideoCache]");
        this.blobUrl = this.createObjectURL(blob);
        return this.blobUrl;
      }
    } catch (e) {
      logger.error(e);
    }
    return void 0;
  }
  async prefetch() {
    const polyfillCreateObjectURL = (polyfill.baidu || polyfill.quark || polyfill.uc) && this.op.forceBlob === false;
    if (this.op.useVideoDBCache && !polyfillCreateObjectURL) {
      const url = await this.checkVideoCache();
      if (url)
        return url;
    }
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", this.op.videoUrl, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 304) {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            const rs = fileReader.result;
            let data;
            if (this.op.useMetaData) {
              data = parser.getdata(rs);
              if (data) {
                this.renderer.videoEntity.setConfig(data);
              }
            }
            if (!polyfillCreateObjectURL) {
              const raw = atob(rs.slice(rs.indexOf(",") + 1));
              const buf = Array(raw.length);
              for (let d = 0; d < raw.length; d++) {
                buf[d] = raw.charCodeAt(d);
              }
              const arr = new Uint8Array(buf);
              const blob = new Blob([arr], { type: "video/mp4" });
              if (this.op.useVideoDBCache) {
                db.model().insert(this.op.videoUrl, { blob, data });
              }
              this.blobUrl = this.createObjectURL(blob);
              resolve(this.blobUrl);
            } else {
              resolve(this.op.videoUrl);
            }
          };
          fileReader.readAsDataURL(xhr.response);
        } else {
          reject(new Error("http response invalid" + xhr.status));
        }
      };
      xhr.send();
    });
  }
}
async function yyEva(options) {
  const op = __spreadValues(__spreadValues({}, {
    showVideo: false,
    useWorker: false,
    loop: true,
    videoUrl: "",
    videoID: null,
    dataUrl: "",
    offset: 0,
    mute: true,
    usePrefetch: true,
    useBitmap: true,
    useAccurate: true,
    useMetaData: false,
    alphaDirection: "left",
    useVideoDBCache: true,
    useFrameCache: true,
    useOfsRender: false,
    resizeCanvas: "percent",
    showPlayerInfo: true,
    forceBlob: false
  }), options);
  if (op.useMetaData) {
    op.usePrefetch = true;
  }
  if (op.useFrameCache) {
    op.useOfsRender = true;
  }
  if (!self.createImageBitmap) {
    op.useBitmap = false;
  }
  if (!self.OffscreenCanvas || !op.useOfsRender) {
    op.useOfsRender = false;
    op.useFrameCache = false;
  }
  if (!self.indexedDB) {
    op.useVideoDBCache = false;
  }
  logger.setup({ level: op.logLevel, showtips: !!op.showPlayerInfo });
  if (polyfill.weixin && !wxIsReady && polyfill.ios)
    await wxReady();
  const player = new EVideo(op);
  if (op.onStart)
    player.onStart = op.onStart;
  if (op.onStop)
    player.onStop = op.onStop;
  if (op.onEnd)
    player.onEnd = op.onEnd;
  if (op.onPause)
    player.onPause = op.onPause;
  if (op.onResume)
    player.onResume = op.onResume;
  if (op.onProcess)
    player.onProcess = op.onProcess;
  if (op.onError)
    player.onError = op.onError;
  await player.setup();
  op.showPlayerInfo && versionTips(op);
  return player;
}
const version = config.version;
const mode = config.mode;
export { yyEva as default, mode, version, yyEva };
//# sourceMappingURL=yyeva.js.map
